import { getGetFrontRichiesteIdQueryKey } from '@framework/api-client';
import { QueryClient } from 'react-query';

/**
 * Invalida la query della richiesta e di tutte le sue sotto-risorse
 * (pagamenti, oneri, preventivi, ...) per riallineare i dati mostrati.
 */
export function invalidateSubmissionQueries(
  queryClient: QueryClient,
  submissionId: string,
): Promise<void> {
  const submissionKey = getGetFrontRichiesteIdQueryKey(submissionId)[0];
  return queryClient.invalidateQueries({
    predicate: ({ queryKey }) => {
      const key = queryKey[0];
      // Confine sul path: senza, un id a prefisso comune (es. "123" e "1234")
      // coinvolgerebbe anche le query di un'altra richiesta
      return (
        typeof key === 'string' &&
        (key === submissionKey || key.startsWith(`${submissionKey}/`))
      );
    },
  });
}
